<footer>
  <p>Jesteer is an open source product. If you'd like to contribute, send us an email at <a href="mailto:jesteer.dev@gmail.com">jesteer.dev@gmail.com</a> | <a href="/privacypolicy.html">Privacy Policy</a></p>
</footer>

<style>
  footer {
    display: flex;
    justify-content: center;
    text-align: center;
    background-color: black;
    color: white;
    padding: 2rem;
    font-size: small;
  }
  a {
    color: white;
    text-decoration: none;
  }
</style>